import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Row, Col, Collapse, Container, Navbar, NavbarBrand } from 'reactstrap'
import { useHistory, useLocation } from 'react-router-dom'
import AuthContext from 'context/auth/authContext'

const SubmissionNavbar = ({ sidebarOpen }) => {
  const location = useLocation()
  const history = useHistory()
  const authContext = useContext(AuthContext)

  const { userRole } = authContext

  const [collapseOpen, setCollapseOpen] = useState(false)
  const [color, setColor] = useState('navbar-transparent')

  const updateColor = useCallback(() => {
    if (window.innerWidth < 993 && collapseOpen) {
      setColor('bg-white')
    } else {
      setColor('navbar-transparent')
    }
  }, [collapseOpen])

  useEffect(() => {
    window.addEventListener('resize', updateColor)
    if (
      window.outerWidth < 993 &&
      history.location.pathname !== location.pathname &&
      document.documentElement.className.indexOf('nav-open') !== -1
    ) {
      document.documentElement.classList.toggle('nav-open')
    }
  }, [history, location.pathname, updateColor])

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle('nav-open')
  }

  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  const toggleCollapse = () => {
    setCollapseOpen(!collapseOpen)
    if (!collapseOpen) {
      setColor('bg-white')
    } else {
      setColor('navbar-transparent')
    }
  }

  return (
    <>
      <Navbar
        className={classnames('navbar-absolute fixed-top', color)}
        expand="lg"
      >
        <Container fluid>
          <div className="navbar-wrapper">
            <div
              className={classnames('navbar-toggle', {
                toggled: sidebarOpen,
              })}
            >
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleSidebar}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <NavbarBrand href="#pablo" onClick={e => e.preventDefault()}>
              <span className="d-none d-md-block title-mt">
                <h5>
                  {userRole === 'submitter'
                    ? 'Authorized Product List Submission System'
                    : 'WIC Review and Approval'}
                </h5>
              </span>
            </NavbarBrand>
          </div>
          <button
            aria-controls="navigation-index"
            aria-expanded={collapseOpen}
            aria-label="Toggle navigation"
            className="navbar-toggler"
            data-toggle="collapse"
            type="button"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </button>
          <Collapse
            className="justify-content-end"
            navbar
            isOpen={collapseOpen}
          />
        </Container>
        <div className={'text-right'}>
          <a href="/auth/logout" className={'text-decoration-none'}>
            <span className="mr-3 d-none d-lg-block">
              <Row className={'logout-mt'}>
                <Col md={1}>
                  <i className="fas fa-sign-out-alt fa-2x fa-flip-horizontal"></i>
                </Col>
                <Col md={4} className={'ml-2'}>
                  <h5>Log&nbsp;Out</h5>
                </Col>
              </Row>
            </span>
          </a>
        </div>
      </Navbar>
    </>
  )
}

SubmissionNavbar.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  // handleMiniClick: PropTypes.func,
  sidebarOpen: PropTypes.bool,
}

export default SubmissionNavbar
